import type { ItemDefinition } from '@/types';
import { SURVEY_ITEM_ALIASES } from '@/constants/surveyItemAliases';
import {
  OIV7_CLASSES,
  SURVEY_ITEM_CLASS_INDICES,
} from '@/constants/oiv7Classes';

export function buildDetectionLabelMap(
  itemDefinitions: ItemDefinition[]
): Map<string, string> {
  const defsByNormalizedName = new Map<string, string>();
  for (const d of itemDefinitions) {
    defsByNormalizedName.set(d.name.toLowerCase().trim(), d.name);
  }

  const map = new Map<string, string>();

  for (let i = 0; i < OIV7_CLASSES.length; i++) {
    if (!SURVEY_ITEM_CLASS_INDICES.has(i)) continue;
    const oivName = OIV7_CLASSES[i];
    const alias = SURVEY_ITEM_ALIASES[oivName];

    // Alias → exact ItemDefinition name match (highest priority)
    if (alias) {
      const defName = defsByNormalizedName.get(alias.toLowerCase().trim());
      if (defName) {
        map.set(oivName, defName);
        continue;
      }
    }

    // Raw OIV7 name → exact ItemDefinition name match
    const directMatch = defsByNormalizedName.get(oivName.toLowerCase().trim());
    if (directMatch) {
      map.set(oivName, directMatch);
      continue;
    }

    // Fall back to the alias as a display label (no ItemDefinition match found)
    if (alias) map.set(oivName, alias);
  }

  return map;
}
